import React, { useState } from 'react';
import PropTypes, { any } from 'prop-types';

import { CheckBox } from '../../../components/Form';

import styles from './nextAvailable.scss';
import SelectAllCheckBox from '../DayPlanner/SelectAllCheckBox';

const AddDrawsListItem = (props) => {
    const {
        draw,
        className,
        field,
        index,
        formApi,
    } = props;

    const hasChildDraws = draw?.childDraws?.length > 0;

    const [isDrawOpen, setIsDrawOpen] = useState(false);

    const onClickItem = () => {
        if (!hasChildDraws) {
            return;
        }

        setIsDrawOpen(!isDrawOpen);
    };

    const updateParentCHildDrawsSelection = (selected = true) => {
        const parentDrawObject = formApi.getValue([field, index]);
        if (parentDrawObject.isSelectable) {
            formApi.setValue([field, index, 'isSelected'], selected);
            formApi.setValue('changed', true);
        }
        parentDrawObject.childDraws.forEach((childDraw, i) => {
            if (childDraw.isSelectable) {
                formApi.setValue([field, index, 'childDraws', i, 'isSelected'], selected);
                formApi.setValue('changed', true);
            }
        });
    };

    const onDeSelectAllChildDraws = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();

        updateParentCHildDrawsSelection(false);
        setIsDrawOpen(true);
    };

    const onSelectAllChildDraws = (ev) => {
        ev.stopPropagation();
        ev.preventDefault();

        updateParentCHildDrawsSelection(true);
        setIsDrawOpen(true);
    };

    const onChangeChildDraw = (childDrawIndex) => (value, ev) => {
        ev.stopPropagation();
        ev.preventDefault();

        const parentDrawObject = formApi.getValue([field, index]);

        parentDrawObject.childDraws.splice(childDrawIndex, 1);

        const atLeastOnceChildDrawSelected = parentDrawObject.childDraws.some((childDraw) => childDraw.isSelected);
        const isParentDrawSelected = atLeastOnceChildDrawSelected || value;

        if (parentDrawObject.isSelectable) {
            formApi.setValue([field, index, 'isSelected'], isParentDrawSelected);
            formApi.setValue('changed', true);
        }
    };

    const onChangeParentDraw = (value, ev) => {
        ev.stopPropagation();
        ev.preventDefault();

        formApi.setValue('changed', true);
    };

    const isDrawSelected = formApi.getValue([field, index, 'isSelected']);

    return (
        <div className={`${styles.addDrawsListItem} ${className || ''}`}>
            <div
                className={`d-flex align-items-center ${styles.section} ${hasChildDraws ? 'cursor-pointer' : ''}`}
                onClick={onClickItem}
                data-testid={`next-available.add-draw-${draw.id}.header`}
            >
                {hasChildDraws && (
                    <>
                        <SelectAllCheckBox
                            className={styles.checkBox}
                            onClearAll={onDeSelectAllChildDraws}
                            onSelectAll={onSelectAllChildDraws}
                            areSomeSelected={isDrawSelected}
                            disabled={!draw.isSelectable}
                            data-testid={`next-available.add-draw-${draw.id}.select-all-checkbox`}
                        />
                        <div
                            className={styles.arrow}
                            data-testid={`next-available.add-draw-${draw.id}.arrow`}
                        >
                            {isDrawOpen && (
                                <i className={`fas fa-solid fa-caret-down`} />
                            )}
                            {!isDrawOpen && (
                                <i className={`fas fa-solid fa-caret-right`} />
                            )}
                        </div>
                        <div
                            className="flex-1 mw0"
                            data-testid={`next-available.add-draw-${draw.id}.name`}
                        >
                            {draw.name}
                        </div>
                    </>
                )}
                {!hasChildDraws && (
                    <CheckBox
                        id={`${field}${index}isSelected`}
                        field={[field, index, 'isSelected']}
                        formGroupCssClass={`${styles.checkBox} ${styles.addMargin}`}
                        disabled={!draw.isSelectable}
                        customLabel={draw.name}
                        onChange={onChangeParentDraw}
                        data-testid="draw-edit.itemitemis-selected-checkbox"
                    />
                )}
            </div>
            {hasChildDraws && isDrawOpen && (
                <div className={styles.childDraws}>
                    {draw.childDraws.map((childDraw, i) => {
                        return (
                            <div
                                key={`child-draw-${childDraw.id}`}
                                className={`d-flex align-items-center ${styles.section} ${hasChildDraws ? 'cursor-pointer' : ''}`}
                            >
                                <CheckBox
                                    id={`${field}${index}childDraws${i}isSelected`}
                                    field={[field, index, 'childDraws', i, 'isSelected']}
                                    formGroupCssClass={`${styles.checkBox} ${styles.addMargin}`}
                                    disabled={!childDraw.isSelectable}
                                    onChange={onChangeChildDraw(i)}
                                    customLabel={childDraw.name}
                                    data-testid={`next-available.add-draw-${draw.id}.child-${childDraw.id}`}
                                />
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

AddDrawsListItem.propTypes = {
    draw: PropTypes.objectOf(any),
    className: PropTypes.string,
    field: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    formApi: PropTypes.objectOf(any).isRequired,
};

AddDrawsListItem.defaultProps = {
    draw: {},
    className: null,
};

export default AddDrawsListItem;
